import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { InventoryService } from '../../../services/inventory.service';
import { Product, gridPageRequest } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { SalesService } from '../../../services/sales.service';
import jsPDF from 'jspdf';
import { Table } from 'primeng/table';
import { debounceTime, Subject, switchMap } from 'rxjs';
import { AdministratorService } from '../../../services/administrator.service';
import { ReportLookupComponent } from '../../Reports/report-lookup/report-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportCenterService } from '../../../services/report-center.service';

@Component({
  selector: 'app-list-products',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-products.component.html',
  styleUrl: './list-products.component.scss'
})
export class ListProductsComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  selectedProduct: any[] = [];
  products: any[] = [];
  pdfproductlist: any[] = [];
  layout: 'list' | 'grid' = 'list';
  loading: boolean = false;
  loader: boolean = false;
  searchKey: string = '';
  private searchTerms = new Subject<string>();
  userList: any;
  warehouseId: number | undefined;
  constructor(private router: Router, private inventoryService: InventoryService, public dialogService: DialogService, public ref: DynamicDialogRef,  private messageService: MessageService, private confirmationService: ConfirmationService, private salesService: SalesService, private administratorService: AdministratorService,private reportService : ReportCenterService) { }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Product List';
    this.getProducts();
    this.searchEffect();
    this.getUserList();
    this.searchTerms.pipe(
      debounceTime(300),
      switchMap(term => this.salesService.autoSearchProduct(term))
    ).subscribe(data => {
      if (data) {
        this.products = data.map((product: any) => ({
          ...product,
          // productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg',
          isActive: true,
          hsnCode: product.gst.hsnCode
        }));
        this.setWarehouseFromSessionAndUpdateInventory();
        if (this.dt1) {
          this.dt1.first = 0;
        }
      } else {
        this.products = [];
      }
    }, error => {
      console.log(error);
    });
  }


  onSearchChange(searchValue: string) {
    this.searchTerms.next(searchValue);
  }

  Createproduct() {
    this.router.navigate(['/home/createProducts']);
  }

     // this.products = data.products.map((product: any) => {
          //   return {
          //     ...product,
          //     //productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
          //   };
          // });
  getProducts(): void {
    this.inventoryService.getProducts(this.pageRequest).subscribe({
      next: (data: any) => {
        if (data && data.products) {
         // this.products = data.products
       //
        this.products = data.products.map((product: any) => {
            return {
              ...product,
              productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
             ,hsnCode: product.hsnCode ?? '',   
              GSTRate: product.gstRate ?? 0 
            }
            ;
          });
          this.setWarehouseFromSessionAndUpdateInventory();
        } else {
          this.products = [];
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  //  getProducts(): void {
  //   this.inventoryService.getProducts(this.pageRequest).subscribe({
  //     next: (data: any) => {
  //       if (data && data.products) {
  //         this.products = data.products
  //         this.products = data.products.map((product: any) => {
  //           return {
  //             ...product,
  //             productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
  //           };
  //         });
  //         this.setWarehouseFromSessionAndUpdateInventory();
  //       } else {
  //         this.products = [];
  //       }
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }


  //  getProductsToImage(): void {
  //   this.inventoryService.getProducts(this.pageRequest).subscribe({
  //     next: (data: any) => {
  //       if (data && data.products) {
  //         this.products = data.products
  //          this.products = data.products.map((product: any) => {
  //           return {
  //             ...product,
  //             productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg'
  //           };
  //         });
  //      //
  //         this.setWarehouseFromSessionAndUpdateInventory();
  //       } else {
  //         this.products = [];
  //       }
  //     },
  //     error: error => {
  //       console.log(error);
  //     }
  //   });
  // }

  // showReport(value:any) {
  //     this.ref = this.dialogService.open(ReportLookupComponent, {
  //       header: `Product Master `,
  //       width: '100%',
  //       data: { ReportName:'Product_Master' }

  //     });

  //   }
  getExportProducts() {
    const data = {
      pageIndex: 0,
      pageSize: 1000000,
      id: 0
    };
    this.loader = true;
    this.inventoryService.getExportProducts(data).subscribe({
      next: (data: any) => {
        if (data) {
          this.pdfproductlist = data.products.map((product: any) => {
            return {
              ...product,
              productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg',
              isActive: true
            };
          });
          this.loader = false;
          this.exportAsPDF();
        } else {
          this.loader = false;
        }
      },
      error: error => {
        this.loader = false;
        console.log(error);
      }
    });
  }



  editProduct(data?: any) {
    if (data) {
      const productData = data;
      this.router.navigate(['/home/createProducts'], { queryParams: { 'productId': productData.productId }, skipLocationChange: false, });
    } else {
      const productData = this.selectedProduct[0];
      // console.log(productData);
      this.router.navigate(['/home/createProducts'], { queryParams: { 'productId': productData.productId }, skipLocationChange: false, });
    }

  }

  loadProducts(event: any) {
    if(this.searchKey)
      return;

    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getProducts();
  }

  deleteProduct() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;

        var productIds = _.map(this.selectedProduct, 'productId');

        this.inventoryService.deleteProduct(productIds).subscribe({
          next: (data: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Product deleted successfully.' });
            this.loader = false;
            this.selectedProduct = [];
            this.getProducts();
          },
          error: error => {
            this.loader = false;
            console.log(error);
          }
        })
      },
      reject: () => {
      }
    });

  }

  searchProduct() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter search keyword' });
      return;
    }
    this.salesService.autoSearchProduct(this.searchKey).subscribe(
      (data: any) => {
       // console.log(data);
        
        if (data) {
          this.products = data.map((product: any) => {
            return {
              ...product,
              // productImage: product.productImage ? `data:image/jpeg;base64,${product.productImage}` : './assets/no-image.jpg',
              isActive: true,
              hsnCode: product.gst.hsnCode
            };
          });
          this.setWarehouseFromSessionAndUpdateInventory();
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  // craeted by shyam on 07/06/2024. For export the product list .......
  // start...

  exportAsPDF(): void {
    const productsForPDF = [...this.pdfproductlist];
    const doc = new jsPDF('landscape');
    const margin = 12;
    const lineHeight = 9;
    const fontSize = 8;
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    let yOffset = margin;
    const headers = [
      { title: 'Sr. No.', key: 'serialNumber' },
      { title: 'Prod Code', key: 'productCode' },
      { title: 'Product Name', key: 'productName' },
      { title: 'Product Type', key: 'productType' },
      { title: 'IsTaxable', key: 'isTaxable' },
      { title: 'HSN Code', key: 'hsnCode' },
      { title: 'GST     ', key: 'gstId' },
      { title: 'UnitOfMeasure', key: 'unitsOfMeasure' },
      { title: 'Standard Cost', key: 'standardCost' },
      { title: 'Sales Price', key: 'salesPrice' },
      { title: 'Barcode  ', key: 'barcode' },
    ];

    const columnWidths: number[] = Array(headers.length).fill(0);

    const drawHeader = () => {
      let xOffset = margin;

      headers.forEach((header, index) => {
        doc.setLineWidth(0.1);
        doc.setDrawColor(0);
        doc.setFillColor(135, 206, 235);
        doc.rect(xOffset, yOffset, columnWidths[index], lineHeight, 'F');
        doc.text(header.title, xOffset + columnWidths[index] / 2, yOffset + lineHeight / 2, { align: 'center' });
        doc.rect(xOffset, yOffset, columnWidths[index], lineHeight);
        xOffset += columnWidths[index];
      });

      yOffset += lineHeight;

      doc.setFillColor(135, 206, 235);
      doc.rect((pageWidth - titleWidth) / 2 - 2, margin - lineHeight + 2, titleWidth + 4, lineHeight + 4, 'F');
      doc.text(title, (pageWidth - titleWidth) / 2, margin);
      doc.setLineWidth(0.1);
      doc.rect(margin, yOffset, pageWidth - 2 * margin, lineHeight);
    };

    doc.setFontSize(fontSize);
    doc.setFont('helvetica', 'bold');

    const title = 'Product List';
    const titleWidth = doc.getStringUnitWidth(title) * fontSize / doc.internal.scaleFactor;
    doc.text(title, (pageWidth - titleWidth) / 2, yOffset);
    yOffset += lineHeight;

    doc.setFontSize(8);

    headers.forEach((header, index) => {
      const headerWidth = doc.getStringUnitWidth(header.title) * fontSize / doc.internal.scaleFactor;
      columnWidths[index] = Math.max(columnWidths[index], headerWidth);

      productsForPDF.forEach((product, i) => {
        if (header.key === 'serialNumber') {
          product[header.key] = i + 1;
        }
        const value = product[header.key] != null ? product[header.key].toString() : '';
        const valueWidth = doc.getStringUnitWidth(value) * fontSize / doc.internal.scaleFactor;
        columnWidths[index] = Math.max(columnWidths[index], valueWidth);
      });
    });

    const totalWidth = columnWidths.reduce((acc, width) => acc + width, 0);
    const scaleFactor = (pageWidth - 2 * margin) / totalWidth;
    columnWidths.forEach((width, index) => {
      columnWidths[index] = width * scaleFactor;
    });

    drawHeader();

    let index = 0;
    while (index < productsForPDF.length) {
      const productChunk = productsForPDF.slice(index, index + 5);

      productChunk.forEach(product => {
        if (yOffset + lineHeight > pageHeight - margin) {
          doc.addPage();
          yOffset = margin;

          doc.setFontSize(fontSize);
          doc.setFont('helvetica', 'bold');
          doc.text(title, (pageWidth - titleWidth) / 2, yOffset);
          yOffset += lineHeight;

          drawHeader();
        }

        let xOffset = margin;
        headers.forEach((header, index) => {
          const value = product[header.key] != null ? product[header.key].toString() : '';
          doc.setLineWidth(0.1);
          doc.setDrawColor(0);
          doc.setFont('helvetica', 'normal');
          doc.rect(xOffset, yOffset, columnWidths[index], lineHeight);
          if (header.key === 'standardCost' || header.key === 'salesPrice' || header.key === 'gstId') {
            doc.text(parseFloat(value).toFixed(2), xOffset + columnWidths[index] - 2, yOffset + lineHeight / 2, { align: 'right' });
          } else {
            doc.text(value, xOffset + 2, yOffset + lineHeight / 2, { align: 'left' });
          }
          xOffset += columnWidths[index];
        });

        yOffset += lineHeight;
      });
      index += 5;
    }
    doc.save('ProductDetails.pdf');
  }
  // end.....

  refreshData(): void {
    if (this.dt1) {
      this.dt1.reset();
    }
    this.searchKey = '';
    this.getProducts();
  }

  getUserList(): void {
    this.administratorService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        this.setWarehouseFromSessionAndUpdateInventory();
      },
      error: error => {
        console.error('Error fetching user info:', error);
      }
    });
  }

 setWarehouseFromSessionAndUpdateInventory(): void {
  if (!this.userList || this.userList.length === 0) {
    return;
  }
  const authData = JSON.parse(localStorage.getItem('auth') || '{}');
  const userId = authData.user?.id;

  if (!userId) {
    return;
  }
  const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);

  if (user && user.warehouseId) {
    this.warehouseId = user.warehouseId;
    this.inventoryService.getInventoryStatusByWarehouse(this.warehouseId).subscribe({
        next: (inventoryData: any) => {
          const inventoryList = Array.isArray(inventoryData)
            ? inventoryData
            : inventoryData?.data ?? [];

          inventoryList.forEach((inventoryItem: any) => {
            const product = this.products.find(
              p => p.productId === inventoryItem.productId
            );
            if (product) {
              product.quantityOnHand = inventoryItem.quantityOnHand;
              product.quantityAvailable = inventoryItem.quantityAvailable;
            }
          });
        },
        error: error => {
          console.log(error);
        }
      });
  }
}
  showReport(value: any): void {
    const formCode = 'Product_Master';

    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        this.ref = this.dialogService.open(ReportLookupComponent, {
          header: `Product Master `,
          width: '100%',
          data: {
            // OrderNo: value.projectBoMId,
            ReportName: report.formName,
            ReportPath: report.path
          }
        });
          this.ref.onClose.subscribe(() => {
          this.searchKey = '';
        });
      },
      error: (err) => {
        console.error('Report not found for form code:', formCode, err);
      }
    });
  }


  
  placeholder: string = 'Search By ';
  private messages: string[] = ['Product Code', 'Product Name'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
